import { UnitType } from './videoRoiCalculatorTypes';

/**
 * Converts a measurement from meters to feet.
 *
 * @param meters - The length in meters to convert
 * @returns The equivalent length in feet
 *
 * @example
 * // Returns 16.4042
 * convertMetersToFeet(5);
 */
const convertMetersToFeet = (meters: number): number => {
  const METER_TO_FEET = 3.28084;
  return meters * METER_TO_FEET;
};

/**
 * Converts a value from meters to the specified unit.
 *
 * @param valueInMeters - The value in meters to convert
 * @param unit - The unit to convert to (either 'm' for meters or 'ft' for feet)
 * @returns The value converted to the specified unit. If unit is 'm', returns the original value;
 *          otherwise converts from meters to feet.
 */
export const convertFromMetersToUnit = (valueInMeters: number, unit: UnitType): number => {
  if (unit === 'm') {
    return valueInMeters;
  }
  return convertMetersToFeet(valueInMeters);
};
